import { bindOfflineVouchers, giftQueryOptions, listStaleOfflineVouchers } from '@/entities/gift'
import { getLanguage } from '@/shared/i18n'
import { queryClient } from './providers/query-client'

/** Сколько ждать после старта: первый экран не делит сеть с фоновыми проверками. */
const RECHECK_DELAY_MS = 5_000

/** Как давно бэкенд не подтверждал ваучер, чтобы спросить заново. */
const RECHECK_AFTER_MS = 12 * 60 * 60_000

/** Не больше стольких запросов за запуск — остальные в следующий раз. */
const RECHECK_LIMIT = 5

/**
 * Сохранённые на устройстве ваучеры, которые человек давно не открывал,
 * перепроверяются в фоне: погашенный, возвращённый или заблокированный
 * подарок уходит с устройства, даже если его экран больше не открывают
 * (решение пользователя 02.10.2026, итерация 7). Запрос — тот же, что у
 * экрана подарка: запись обновляет или удаляет его `queryFn`.
 *
 * Без сети не проверяем — запись остаётся до ответа бэкенда.
 */
const recheckStaleVouchers = async (): Promise<void> => {
  for (const giftId of listStaleOfflineVouchers(RECHECK_AFTER_MS, RECHECK_LIMIT)) {
    if (!navigator.onLine) {
      return
    }

    try {
      await queryClient.fetchQuery(giftQueryOptions(giftId, getLanguage()))
    } catch {
      // Сеть или сбой бэкенда: запись остаётся до следующего запуска. Отказ
      // подписи и блокировку покажет оболочка — их ловит `QueryCache`.
    }
  }
}

/**
 * Офлайн-ваучеры при старте: привязать хранилище к Telegram ID (чужие записи
 * стираются) — до первого запроса подарка, — и запланировать фоновую проверку.
 */
export const setupOfflineVouchers = (telegramId: number | null): void => {
  bindOfflineVouchers(telegramId)

  if (telegramId !== null) {
    window.setTimeout(() => void recheckStaleVouchers(), RECHECK_DELAY_MS)
  }
}
